import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Self,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClickSearchBar } from '@rivethealth/data/analytics/account-analytics-events';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AccountAnalyticsService } from '../../app/account/account-analytics.service';
import { StringParam } from '../state/route';
import { RouteService } from '../state/route.service';

/**
 * @deprecated Use riv-search instead.
 * @see https://rivethealth.github.io/design-system/?path=/story/lib-input-search--example
 */
@Component({
  selector: 'deprecated-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DeprecatedSearchFieldComponent),
    },
    RouteService,
  ],
})
export class DeprecatedSearchFieldComponent
  implements ControlValueAccessor, OnInit, OnDestroy
{
  constructor(
    @Self() private readonly routeService: RouteService,
    @Optional() private readonly analyticsService: AccountAnalyticsService,
  ) {}

  @Input() tableName: string | null = null;

  @Input() autoFocus: boolean;

  @Input() purp: boolean;

  @Input() placeholder = 'Search';

  @Input() queryParamName: string = 'searchQuery';

  disabled = new BehaviorSubject<boolean>(false);

  value = new Subject<string | null>();

  hasText = this.value.pipe(map(v => (v ? v.length > 0 : false)));

  keydown = new EventEmitter<KeyboardEvent>();

  writeValue(value: string | null) {}

  private propagateChange = (_: any) => {};

  registerOnChange(fn: (_: any) => {}) {
    this.propagateChange = fn;
    let initial = true;
    this.propagateChangeSubscription = this.value.subscribe(value => {
      if (!initial || value) {
        this.propagateChange(value);
      }
      initial = false;
    });
  }

  registerOnTouched() {}

  setDisabledState(disabled: boolean) {
    this.disabled.next(disabled);
  }

  @ViewChild('inputElement', { static: false }) inputElement: ElementRef;

  focus() {
    this.inputElement.nativeElement.focus();
  }

  fireFocusAnalyticEvent() {
    if (this.analyticsService && this.tableName) {
      this.analyticsService.logEvent(ClickSearchBar, {
        'table name': this.tableName,
      });
    }
  }

  propagateChangeSubscription: Subscription;
  escapeKeySubscription: Subscription;
  ngOnInit() {
    this.value = this.routeService.query(
      new StringParam(this.queryParamName, ''),
    );
    this.escapeKeySubscription = this.keydown
      .pipe(filter(evt => evt.key === 'Escape' || evt.key === 'Esc'))
      .subscribe(() => {
        this.value.next(null);
      });
  }
  ngOnDestroy() {
    this.propagateChangeSubscription?.unsubscribe();
    this.escapeKeySubscription.unsubscribe();
  }
}
